<div [ngClass]="CssClasses()" class="p-3 border border-2 rounded" [attr.id]="uuid()">
  <div class="row flex-nowrap g-2">
    <div class="col-auto text-center">
      <i [ngClass]="iconClasses()" class="{{ colorScheme().iconColorClass }}" aria-hidden="true" style="font-size: 1.5rem"></i>
    </div>
    <div class="col align-self-center">
      <div class="d-flex">
        @if (showTitle()) {
          <mwe-headline
            [headlineNodeType]="headingNodeType()"
            cssClass="font-size-16 lh-base fw-bold text-secondary mb-2"
            [text]="titleKey()"
            [textParams]="textParamsAsRecord()"
            [id]="uuid()"
            data-test="inline-notification-headline"
          />
          @if (!!infoText()) {
            <mwe-info-text-icon
              [infoTextTitle]="infoText().title | translate"
              [infoTextDescription]="infoText().description | translate"
              colorClass="{{ colorScheme().iconColorClass }}"
            />
          }
        }
      </div>
      @if (messageKey()) {
        <p class="mb-0" data-test="mwe-infobox-text" [innerHTML]="messageKey() | translate: textParamsAsRecord() | safeHtml"></p>
      }
      @for (messageKey of messageKeys(); let last = $last; track $index) {
        <p
          class="mb-0"
          data-test="mwe-infobox-text"
          [class.mb-2]="!last"
          [innerHTML]="messageKey | translate: textParamsAsRecord() | safeHtml"
        ></p>
      }
      <ng-content />
      @if (ctaLabelKey()) {
        <div [ngClass]="ctaWrapperClass()">
          <mwe-button-link
            color="blue"
            size="md"
            data-test="mwe-infobox-button"
            [prependIconClass]="ctaPrependIconClass()"
            [label]="ctaLabelKey()"
            (click)="onCTAClick.emit()"
          />
        </div>
      }
    </div>
  </div>
</div>
